import { z } from 'zod';

export const contactSchema = z.object({
  name: z.string().min(2, 'Name must be at least 2 characters').max(80, 'Name must be at most 80 characters').trim(),
  email: z.string().email('Please enter a valid email address').toLowerCase().trim(),
  company: z.string().min(2, 'Company must be at least 2 characters').max(120, 'Company must be at most 120 characters').trim(),
  role: z.string().max(80, 'Role must be at most 80 characters').trim().optional(),
  budget: z.enum(['<25k', '25-100k', '100-500k', '500k+'], {
    error: 'Please select a budget range',
  }),
  message: z.string().min(20, 'Message must be at least 20 characters').max(2000, 'Message must be at most 2000 characters').trim(),
  // Honeypot — must remain empty; bots fill it, humans don't see it.
  website: z.string().max(0),
});

export type ContactInput = z.infer<typeof contactSchema>;
